import { render, staticRenderFns } from "./bindSuccess.vue?vue&type=template&id=748b20e1&scoped=true"
import script from "./bindSuccess.vue?vue&type=script&lang=js"
export * from "./bindSuccess.vue?vue&type=script&lang=js"
import style0 from "./bindSuccess.vue?vue&type=style&index=0&id=748b20e1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b20e1",
  null
  
)

export default component.exports